export const kardiaPools = [
    {
      id: 'sen-maxi',
      logo: 'single-assets/SEN.png',
      name: 'SEN Maxi',
      token: 'SEN',
      tokenDescription: 'SleepEarn.Finance',
      tokenAddress: '0xb697231730C004110A86f51BfF4B8DD085c0CB28',
      tokenDecimals: 18,
      earnedToken: 'pillowSEN',
      earnedTokenAddress: '0x4EdB55Ab9aF276786468214c401c48751Da91e2a',
      earnContractAddress: '0x4EdB55Ab9aF276786468214c401c48751Da91e2a',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'tokens',
      oracleId: 'SEN',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'SleepEarn.Finance',
      assets: ['SEN'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/exchange/0x43951c209003A70dCA94c2a5b09342C9c84E58Ac',
    },
    {
      id: 'kaidex_v3-kdx-kai',
      name: 'KDX-KAI KDXLP',
      token: 'KDX-KAI KDXLP',
      tokenDescription: 'KAIDEX V3 AMM',
      tokenDescriptionUrl: 'https://kaidex.io/reward',
      tokenAddress: '0xea0137FE9Dd7FD4A293392B888ce2891E3236957',
      tokenDecimals: 18,
      earnedToken: 'pillowKAIDEXV3KDX-KAI',
      earnedTokenAddress: '0xa6dDfAaEB07eEEf299ab94f75475ecb2d7D82867',
      earnContractAddress: '0xa6dDfAaEB07eEEf299ab94f75475ecb2d7D82867',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'kaidex_v3-kdx-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'KAIDEX V3 Farming',
      assets: ['KDX', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/trade?inputCurrency=KAI&outputCurrency=0xE9caC5d99375d02Fb506bE890011B2F57fC614E1',
      addLiquidityUrl: 'https://kaidex.io/add/KAI/0xE9caC5d99375d02Fb506bE890011B2F57fC614E1',
    },
    {
      id: 'kaidex_v3-kdx-usdc',
      name: 'KDX-USDC KDXLP',
      token: 'KDX-USDC KDXLP',
      tokenDescription: 'KAIDEX V3 AMM',
      tokenDescriptionUrl: 'https://kaidex.io/reward',
      tokenAddress: '0x750266D3efc2d9274022CbD9688B83b3f36dCEd2',
      tokenDecimals: 18,
      earnedToken: 'pillowKAIDEXV3KDX-USDC',
      earnedTokenAddress: '0x720F115e92541497F4085ad3c29e299e0a3Ce272',
      earnContractAddress: '0x720F115e92541497F4085ad3c29e299e0a3Ce272',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'kaidex_v3-kdx-usdc',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'KAIDEX V3 Farming',
      assets: ['KDX', 'USDC'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/trade?inputCurrency=KAI&outputCurrency=0xE9caC5d99375d02Fb506bE890011B2F57fC614E1',
      addLiquidityUrl: 'https://kaidex.io/add/0x765277EebeCA2e31912C9946eAe1021199B39C61/0xE9caC5d99375d02Fb506bE890011B2F57fC614E1',
    },
    {
      id: 'kaidex_v3-kai-usdc',
      name: 'KAI-USDC KDXLP',
      token: 'KAI-USDC KDXLP',
      tokenDescription: 'KAIDEX V3 AMM',
      tokenDescriptionUrl: 'https://kaidex.io/reward',
      tokenAddress: '0x1c107492b20b12CD384E193b4426da97354CbEA3',
      tokenDecimals: 18,
      earnedToken: 'pillowKAIDEXV3KAI-USDC',
      earnedTokenAddress: '0xCBd7aA9916B2826E5d34337407F0b71dd130aD79',
      earnContractAddress: '0xCBd7aA9916B2826E5d34337407F0b71dd130aD79',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'kaidex_v3-kai-usdc',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'KAIDEX V3 Farming',
      assets: ['KAI', 'USDC'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/trade?inputCurrency=0x765277EebeCA2e31912C9946eAe1021199B39C61&outputCurrency=KAI',
      addLiquidityUrl: 'https://kaidex.io/add/KAI/0x765277EebeCA2e31912C9946eAe1021199B39C61',
    },
    {
      id: 'beco-sen-kai',
      name: 'SEN-KAI KLP',
      token: 'SEN-KAI KLP',
      tokenDescription: 'BecoSwap-KaiDex',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x43951c209003A70dCA94c2a5b09342C9c84E58Ac',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoSEN-KAI',
      earnedTokenAddress: '0x27ea5A8A132ADfc27d44aBA450091d3738fC32cC',
      earnContractAddress: '0x27ea5A8A132ADfc27d44aBA450091d3738fC32cC',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco-sen-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap-KaiDex',
      assets: ['SEN', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.1%',
      buyTokenUrl: 'https://kaidex.io/exchange/0x43951c209003A70dCA94c2a5b09342C9c84E58Ac',
      addLiquidityUrl: 'https://kaidex.io/portfolio/add/0x43951c209003A70dCA94c2a5b09342C9c84E58Ac',
    }, 
    {
      id: 'beco_amm-sen-kai',
      name: 'SEN-KAI Beco-LP',
      token: 'SEN-KAI Beco-LP',
      tokenDescription: 'BecoSwap AMM',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0xCE853E8145BAD98Ecb25374adA9cE579FdE099B5',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoAmmSEN-KAI',
      earnedTokenAddress: '0xBaD70C54Bc56630D1c8C7Eab74197e0b16925544',
      earnContractAddress: '0xBaD70C54Bc56630D1c8C7Eab74197e0b16925544',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco_amm-sen-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap AMM',
      assets: ['SEN', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://becoswap.com/swap?outputCurrency=0xb697231730C004110A86f51BfF4B8DD085c0CB28',
      addLiquidityUrl: 'https://becoswap.com/add/KAI/0xb697231730C004110A86f51BfF4B8DD085c0CB28',
    },
    {
      id: 'beco_amm-beco-kai',
      name: 'BECO-KAI Beco-LP',
      token: 'BECO-KAI Beco-LP',
      tokenDescription: 'BecoSwap AMM',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0xfaa224C2396AF2ffF0AC203f691e3008FEbE1Cc3',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoAmmBeco-KAI',
      earnedTokenAddress: '0xaD6bEe1dcfA84895450d3748eA9DD9D038EE2cAC',
      earnContractAddress: '0xaD6bEe1dcfA84895450d3748eA9DD9D038EE2cAC',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco_amm-beco-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap AMM',
      assets: ['BECO', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://becoswap.com/swap?outputCurrency=0x2Eddba8b949048861d2272068A94792275A51658',
      addLiquidityUrl: 'https://becoswap.com/add/KAI/0x2Eddba8b949048861d2272068A94792275A51658',
    },
    {
      id: 'beco-beco-kai',
      name: 'BECO-KAI KLP',
      token: 'BECO-KAI KLP',
      tokenDescription: 'BecoSwap-KaiDex',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x1eBbF8080149FF07381AFd148bA0AF007f78cD3c',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoBECO-KAI',
      earnedTokenAddress: '0xEC58663962E03B1c209fe505921a98109c54eB9c',
      earnContractAddress: '0xEC58663962E03B1c209fe505921a98109c54eB9c',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco-beco-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap-KaiDex',
      assets: ['BECO', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.1%',
      buyTokenUrl: 'https://kaidex.io/exchange/0x1eBbF8080149FF07381AFd148bA0AF007f78cD3c',
      addLiquidityUrl: 'https://kaidex.io/portfolio/add/0x1eBbF8080149FF07381AFd148bA0AF007f78cD3c',
    },
    {
      id: 'beco_amm-kaba-kai',
      name: 'KABA-KAI Beco-LP',
      token: 'KABA-KAI Beco-LP',
      tokenDescription: 'BecoSwap AMM',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x8cB42715cB8eb5262e92d3B0FA991ED031F1d296',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoAmmKABA-KAI',
      earnedTokenAddress: '0xCc8014Ac4414c577cD3c7123823097E90b96335a',
      earnContractAddress: '0xCc8014Ac4414c577cD3c7123823097E90b96335a',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco_amm-kaba-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap AMM',
      assets: ['KABA', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://becoswap.com/swap?outputCurrency=0x5C5058de24497359Ff64F7318f5C2b5581FF6B05',
      addLiquidityUrl: 'https://becoswap.com/add/KAI/0x5C5058de24497359Ff64F7318f5C2b5581FF6B05',
    },
    {
      id: 'beco-beco-usdt',
      name: 'BECO-USDT KLP',
      token: 'BECO-USDT KLP',
      tokenDescription: 'BecoSwap-KaiDex',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x2C6aC072c8D14DD458B778941a910Ca032712b8a',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoBeco-USDT',
      earnedTokenAddress: '0x390099c49CcA5f3bF441989F857B517B676547B1',
      earnContractAddress: '0x390099c49CcA5f3bF441989F857B517B676547B1',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco-beco-usdt',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap-KaiDex',
      assets: ['BECO', 'USDT'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/exchange/0x2C6aC072c8D14DD458B778941a910Ca032712b8a',
      addLiquidityUrl: 'https://kaidex.io/portfolio/add/0x2C6aC072c8D14DD458B778941a910Ca032712b8a',
    },
    {
      id: 'beco-kai-usdt',
      name: 'KAI-USDT KLP',
      token: 'KAI-USDT KLP',
      tokenDescription: 'BecoSwap-KaiDex',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x8a5c572CE422Da947E2d04a2d8339A2Ea7141dE9',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoKAI-USDT',
      earnedTokenAddress: '0x96609cD5DC21B3BAAd9aBd6e9ec0083465f48A32',
      earnContractAddress: '0x96609cD5DC21B3BAAd9aBd6e9ec0083465f48A32',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco-kai-usdt',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap-KaiDex',
      assets: ['KAI', 'USDT'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/exchange/0x8a5c572CE422Da947E2d04a2d8339A2Ea7141dE9',
      addLiquidityUrl: 'https://kaidex.io/portfolio/add/0x8a5c572CE422Da947E2d04a2d8339A2Ea7141dE9',
    },
    {
      id: 'beco_amm-kphi-kai',
      name: 'KPHI-KAI Beco-LP',
      token: 'KPHI-KAI Beco-LP',
      tokenDescription: 'BecoSwap AMM',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0x425F317fb700d31B78e14E355FeC5437216Adc29',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoAmmKPHI-KAI',
      earnedTokenAddress: '0xb05E0eC79a1d820556c8C720418EFCD288076845',
      earnContractAddress: '0xb05E0eC79a1d820556c8C720418EFCD288076845',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco_amm-kphi-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap AMM',
      assets: ['KPHI', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://becoswap.com/swap?outputCurrency=0x6CD689DefCA80f9F2CBED9D0C6f3B2Cf4abc4598',
      addLiquidityUrl: 'https://becoswap.com/add/KAI/0x6CD689DefCA80f9F2CBED9D0C6f3B2Cf4abc4598',
    },
    {
      id: 'beco-kphi-kai',
      name: 'KPHI-KAI KLP',
      token: 'KPHI-KAI KLP',
      tokenDescription: 'BecoSwap-KaiDex',
      tokenDescriptionUrl: 'https://becoswap.com/farms',
      tokenAddress: '0xd91E71E3486900Eaa41fa37BdD2a161bcDf0AB7e',
      tokenDecimals: 18,
      earnedToken: 'pillowBecoKPHI-KAI',
      earnedTokenAddress: '0xCeb5E1bE5c2cD29259AfeD0D40B83825B949151C',
      earnContractAddress: '0xCeb5E1bE5c2cD29259AfeD0D40B83825B949151C',
      pricePerFullShare: 1,
      tvl: 0,
      oracle: 'lps',
      oracleId: 'beco-kphi-kai',
      oraclePrice: 0,
      depositsPaused: false,
      status: 'active',
      platform: 'BecoSwap-KaiDex',
      assets: ['KPHI', 'KAI'],
      callFee: 0.5,
      withdrawalFee: '0.05%',
      buyTokenUrl: 'https://kaidex.io/exchange/0xd91E71E3486900Eaa41fa37BdD2a161bcDf0AB7e',
      addLiquidityUrl: 'https://kaidex.io/portfolio/add/0xd91E71E3486900Eaa41fa37BdD2a161bcDf0AB7e',
    }
];
